// extracted by mini-css-extract-plugin
export default {"Recommendation":"styles_Recommendation__nYHDl","container":"styles_container__AFDdg","yes":"styles_yes__KbHJq","thumb":"styles_thumb__dSI6Q","no":"styles_no__p+uS2"};